import RelationshipMetadata from "../../RelationshipMetadata";

class OrganizationOrganizationPositionRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "OrganizationOrganizationPosition";
        this.parentEnterpriseComponent = "Organization";
        this.childEnterpriseComponent = "OrganizationPosition";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "OrganizationUSID";
    }
}

export default OrganizationOrganizationPositionRelationshipMetadata;